<template>
  <div id="app">
    <nav>
      <TopNavBar />
    </nav>
    <router-view />
    <Footer />
    <Modal />
  </div>
</template>

<script>
  import { mapActions } from 'vuex'  
  import "bootstrap/dist/css/bootstrap.css";
  import "bootstrap-vue/dist/bootstrap-vue.css";

  // import { RepositoryFactory } from "@/repositories/RepositoryFactory"
  // const ContentRepository = RepositoryFactory.get("content");

  require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

  export default {
    components: {
      TopNavBar: () => import("@/components/TopNavBar.vue"),
      Modal: () => import("@/components/Modal.vue"),
      Footer: () => import("@/components/Footer.vue"),
    },
    methods: {
      ...mapActions(['setNavigation'])
    },
    created (){

     
      const navigation = this.$session.get('navigation')
      
      
      if (navigation){
        this.setNavigation({data: navigation})
      }
      
    }
  }
</script>

<style>

  @import url('css/style.css');

</style>
